import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Activity } from 'lucide-react';

export const DiagnosticCTA = () => {
  return (
    <section className="bg-gradient-to-br from-ink/90 to-ink/80 py-24 text-white border-b border-ground-deep relative overflow-hidden">
      <div className="absolute inset-0 opacity-20 mix-blend-screen" style={{ backgroundImage: 'url(/fingerprint.webp)', backgroundSize: '100% auto', backgroundPosition: 'center', backgroundRepeat: 'repeat-y' }} />
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <div className="w-16 h-16 bg-white/5 rounded-full flex items-center justify-center mx-auto mb-8">
          <Activity className="w-8 h-8 text-rule-3" />
        </div>
        <h2 className="text-3xl md:text-5xl font-serif mb-6 text-white">Uncover Your Team's Friction Pattern</h2>
        <p className="text-lg text-white max-w-2xl mx-auto mb-10 leading-relaxed">
          Stop treating symptoms. Take our free 3-minute diagnostic to identify the core psychological drivers causing silos, burnout, and decision paralysis in your organization.
        </p>
        <Link 
          to="/diagnostic" 
          className="inline-flex items-center gap-3 bg-gradient-to-r from-rule-3/60 to-rule-3/70 text-white px-10 py-5 uppercase tracking-widest text-sm font-bold hover:from-white hover:to-white hover:text-ink transition-all"
        >
          <span>Take the Free Team Diagnostic</span>
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
};
